module.exports = __webpack_public_path__ + "img/let-connect.fedd225b.png";